import { Api, Codes } from '../api';
import store from '../store';
import { ROLES } from '../constants/role';
class Student {
  constructor() {
    this.store = store;
    this.infoPromise = null;
    this.applyPromise = null;
    this.newCount = 0;
    this.cleanCount = 0;
  }
  get infoData() {
    return this.store.state.studentLoginData;
  }
  getInfo() {
    if (this.infoPromise) {
      return this.infoPromise;
    } else if (this.infoData && Object.keys(this.infoData).length) {
      return new Promise(resolve => {
        resolve(this.infoData);
      });
    } else {
      return (this.infoPromise = new Promise((resolve, reject) => {
        Api.get.getStudentInfo().then(res => {
          this.infoPromise = null;
          if (res.status === Codes.SUCCESS) {
            let data = res.data;
            this.store.dispatch('setLoginData', {
              role: ROLES.STUDENT,
              data: data
            });
            resolve(this.infoData);
          }
        });
      }));
    }
  }
  getApplyData() {
    if (this.applyPromise) {
      return this.applyPromise;
    } else {
      return (this.applyPromise = new Promise(resolve => {
        Api.get
          .getStudentApply()
          .then(res => {
            this.applyPromise = null;
            if (res.status === Codes.SUCCESS) {
              resolve(res.data);
            } else {
              resolve({});
            }
          })
          .catch(() => {
            this.applyPromise = null;
            resolve({});
          });
      }));
    }
  }
}
export default new Student();
